// extracted by mini-css-extract-plugin
export default {"main_box":"Nba_main_box__sppc5","skeleton":"Nba_skeleton__0fkJ3"};